import type { CostCoverageV1 } from "@fulcrum5/suite-contracts";

const integerFormatter = new Intl.NumberFormat("en-US");
const percentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 1,
});
const compactNumberFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});
const decimalFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
});
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const EMPTY_ANALYTICS_VALUE = "—";

export function formatAnalyticsInteger(value: number): string {
  return integerFormatter.format(value);
}

export function formatAnalyticsTokens(value: number): string {
  return value < 1_000 ? integerFormatter.format(value) : compactNumberFormatter.format(value);
}

export function formatAnalyticsPercent(value: number | null): string {
  return value === null ? EMPTY_ANALYTICS_VALUE : percentFormatter.format(value);
}

export function formatAnalyticsDuration(value: number | null): string {
  if (value === null) return EMPTY_ANALYTICS_VALUE;
  return value < 1_000
    ? `${integerFormatter.format(value)} ms`
    : `${decimalFormatter.format(value / 1_000)} s`;
}

export function formatAnalyticsUsdMicros(value: number | null): string {
  return value === null ? EMPTY_ANALYTICS_VALUE : currencyFormatter.format(value / 1_000_000);
}

export function costCoverageLabel(coverage: CostCoverageV1, canBeHidden: boolean): string {
  if (coverage === "complete") return "Complete estimate";
  if (coverage === "partial") return "Partial estimate";
  return canBeHidden ? "Cost unavailable or hidden" : "Estimate unavailable";
}
